module.exports = __webpack_public_path__ + "img/logout-variant.320a2be1.svg";